module.exports = {
	"dk": {
		"api_domain": "https://https-tv3sport-mx-api.enetscores.com",
		"language": "1",
		"links": {
			"football": {
				"team_link": "/sport/fodbold/info/hold/:team",
				"player_link": "/sport/fodbold/info/spillere/:player"
			},
			"ice-hockey": {
				"team_link": "/sport/ishockey/info/hold/:team",
				"player_link": "/sport/ishockey/info/spillere/:player"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/enetpulse.json
// module id = 1206
// module chunks = 1 2